import styles from "./Card.module.scss";
import { NavLink } from "react-router-dom";

function Card ({ item, index, row }) {
  const eventInfo = item.date ? item.date.split('.') : []
  return (
    <div className={`${styles.card} `}>
      <div key={index} className={styles.swiperItem}>
        <NavLink
          className={`${
            row === 2 ? styles.swiperItemTitleRow     : styles.swiperItemTitle
          }`}
          to={"/news-detail/" + item.id}
        >
          <div
            className={styles.swiperItemImg}
            style={{ backgroundImage: `url('${item.img}')    ` }}
          >
            <p className={`${styles.date} `}> 
              <span className={`${styles.event}`}>
                {item.eventType}
                {/* {eventInfo[0] ? eventInfo[0].trim(): ''} */}
              </span>
              <span className={`${styles.time}`}>
                {item.time}
              {/* {eventInfo[1] ? eventInfo[1].trim(): ''} */}
              </span>
            </p>
          </div>
        </NavLink>
        <NavLink
          className={`${styles.swiperItemTitle} ${styles.brief}`}
          to={"/news-detail/" + item.id}
        >
          {item.title}
        </NavLink>
        <NavLink
          className={styles.swiperItemDesc}
          to={"/news-detail/" + item.id}
        >
          <div className={styles.brief}>{item.desc}</div>
        </NavLink>
      </div>
    </div>
  );
}

export default Card;
